import { render, staticRenderFns } from "./announce_procedure_buy_declined.vue?vue&type=template&id=abb2f532&scoped=true&"
import script from "./announce_procedure_buy_declined.vue?vue&type=script&lang=js&"
export * from "./announce_procedure_buy_declined.vue?vue&type=script&lang=js&"
import style0 from "./announce_procedure_buy_declined.vue?vue&type=style&index=0&id=abb2f532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb2f532",
  null
  
)

export default component.exports